import { useState, MouseEvent } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { baseInvestorTypeLabels } from 'further-ui/labels';
import Button from 'components/Button';

type Props = {
  loading: boolean;
  onClick: (
    investorType: (typeof baseInvestorTypeLabels)[number]['value'],
  ) => void;
};

const InvestorTypeSelector: React.FC<Props> = ({ loading, onClick }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const openInvestorTypeMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeInvestorTypeMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="manually-pass-certification-button"
        aria-controls={open ? 'investor-type-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        size="extra-small"
        variant="outlined"
        color="primary"
        endIcon={<ArrowDropDown />}
        loading={loading}
        onClick={openInvestorTypeMenu}
      >
        Manually pass certification
      </Button>
      <Menu
        id="investor-type-menu"
        aria-labelledby="manually-pass-certification-button"
        anchorEl={anchorEl}
        open={open}
        onClose={closeInvestorTypeMenu}
      >
        {baseInvestorTypeLabels.map(({ value, label }) => (
          <MenuItem
            key={value}
            onClick={() => {
              onClick(value);
              closeInvestorTypeMenu();
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default InvestorTypeSelector;
